import Vue from 'vue'
import axios from 'axios'
import {baseURL} from '@/config'
import {getStorageItem, removeStorageItem} from '@/utils'
import {KEYS} from '../config'
import {Message} from 'element-ui'
import Router from '@/router/index'
import store from '../store'
// 创建实例
const instance = axios.create({
  baseURL,
  timeout: 30000
})
var loading
let count = 0
// 请求拦截器
instance.interceptors.request.use(conf => {
  count++
  if (loading === undefined) {
    loading = Vue.prototype.$loading({
      lock: true,
      text: conf.loadtext ? conf.loadtext : '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.05)',
      target: document.querySelector('.app-main')
    })
  }

  let data = conf.data
  let appid = getStorageItem('appid')
  let newData = {
    appid: appid ? appid : '440300',
    data: {
      params: data
    }
  }
  conf.data = newData
  const user = store.state.userInfo
  if (user) {
    conf.headers[KEYS.JWTToken] = user.token
  }
  conf.headers.cType = 'PC'
  conf.headers.appName = 'gzzc'
  return conf
}, err => {
  Vue.prototype.$message.error(err)
  Promise.reject(err)
})

// 响应拦截器
instance.interceptors.response.use(res => {
  count--
  if (count == 0) {
    if (undefined !== loading) loading.close()
    loading = undefined
  }
  console.log(res)
  if (res.status === 200) {
    switch (res.data.code) {
      case 1002:  //token过期
        store.dispatch('getUserInfo', null)
        Message.error('登录过期,请重新登录')
        Router.push({path: '/'})
        break
    }
    return res.data

  }
}, err => {
  count--
  if (count == 0) {
    if (undefined !== loading) loading.close()
    loading = undefined
  }

  if (err.response) {
    switch (err.response.status) {
      case 500:
        Message.error('Internal Server Error')
        Router.push({path: '/'})
        break
    }
  }
  if (err.stack.indexOf('timeout') > -1) {
    Message.error('请求超时')
    Router.push({path: '*'})
  }
  Vue.prototype.$message.error(err)
  Promise.reject(err)
})

// console.log(instance)
export default instance



// WEBPACK FOOTER //
// ./src/axios/index.js